import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { appLayoutRoute } from "../../router/rootRoutes";

const indexRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/",
  component: lazyRouteComponent(() => import("./HomePage"), "HomePage"),
});

const friendsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/friends",
  component: lazyRouteComponent(() => import("../../features/social/FriendsPage"), "FriendsPage"),
});

const profileRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/u/$username",
  component: lazyRouteComponent(() => import("../../features/social/ProfilePage"), "ProfilePage"),
});

export const foundationRoutes = [indexRoute, friendsRoute, profileRoute] as const;
